export default __webpack_public_path__ + "static/media/emblemweb.bf3922d3.svg";